export const dropElement = async (cy: any) => {
  return await cy.on('drop', () => {
    cy.container().style.cursor = 'pointer';
  });
};